// Grouped consultation-type options (single-level dropdown)
export const CONSULTATION_TYPES = [
  { value: "Diabetes", group: "chronic" },
  { value: "Hypertension", group: "chronic" },
  { value: "High Cholesterol Levels", group: "chronic" },
  { value: "Multiple (combination of diabetes, hypertension cholesterol)", group: "chronic" },
  { value: "General consultation", group: "general" },
];

// Keywords used to detect a chronic consultation from stored strings
// (kept in lower-case; the older "dyslipidemia" is preserved for backward compat).
export const CHRONIC_KEYWORDS = [
  "diabetes",
  "hypertension",
  "high cholesterol",
  "dyslipidemia",
  "multiple",
];
